import { FullConfiguration } from "@/types/crm/configuration/configuration";
import { airtableDefaultConfigurationElements } from "./defaultConfiguration";

export function getAirtableMetaDataFromConfiguration(defaultConfiguration: FullConfiguration){
    const personalAccessToken = defaultConfiguration?.parameter?.crm?.find(p => p.id === airtableDefaultConfigurationElements.parameter.crm.apiKey)?.value;
    const baseId = defaultConfiguration?.parameter?.project?.find(p => p.id === airtableDefaultConfigurationElements.parameter.project.baseId)?.value;
    const tableNameOrId = defaultConfiguration?.parameter?.survey?.find(p => p.id === airtableDefaultConfigurationElements.parameter.survey.tableName)?.value;
    return {
        apiKey: personalAccessToken,
        baseId,
        tableNameOrId
    }
}